// defines custom column header title, width, and badge to each column
export const columnConfig = [
  { 
    field: 'reasonForTest', 
    title: 'Type of Test', 
    width: '150px', 
    badge: null 
  },
  { 
    field: 'totals', 
    title: 'Total Number Of Test Results (Should equal the sum of Columns 2, 3, 9, 10, 11, and 12)', 
    width: '150px', 
    badge: { type: 'info', content: 1 } 
  },
  { 
    field: 'negatives', 
    title: 'Verified Negative Results', 
    width: '150px', 
    badge: { type: 'info', content: 2 } 
  },
  { 
    field: 'positives', 
    title: 'Verified Positive Results for One or More Drugs', 
    width: '150px', 
    badge: { type: 'info', content: 3 } 
  },
  { 
    field: 'marijuana', 
    title: 'Positive for Marijuana', 
    width: '150px', 
    badge: { type: 'info', content: 4 } 
  },
  { 
    field: 'cocaine', 
    title: 'Positive for Cocaine', 
    width: '150px', 
    badge: { type: 'info', content: 5 } 
  },
  { 
    field: 'pcp', 
    title: 'Positive for PCP', 
    width: '150px', 
    badge: { type: 'info', content: 6 } 
  },
  { 
    field: 'opiates', 
    title: 'Positive for Opiates', 
    width: '150px', 
    badge: { type: 'info', content: 7 } 
  },
  { 
    field: 'amphetamine', 
    title: 'Positive for Amphetamines', 
    width: '150px', 
    badge: { type: 'info', content: 8 } 
  },
  { 
    field: 'adulterated', 
    title: 'Adulterated', 
    width: '150px', 
    badge: { type: 'info', content: 9 } 
  },
  { 
    field: 'substituted', 
    title: 'Substituted', 
    width: '150px', 
    badge: { type: 'info', content: 10 } 
  },
];
